// extracted by mini-css-extract-plugin
export default {"stickyRow":"stickyRow-yk4yoSom"};